import StyleList from './style_list_config';
import {gen_id} from "@/base/base";

//生成一个列的类
class OneColumn {
  constructor({
                tabId,
                pid,
                widgets_id,
                children = [],
                rowType,
                isNewCol,
                newType,
                data = JSON.parse(JSON.stringify(StyleList['layout_column']))
              }) {
    this.name = 'layout_column';
    this.pid = pid;
    this.widgets_id = widgets_id;
    this.data = data;
    if (typeof this.data.col_id === 'undefined') {
      this.data.col_id = gen_id();
    }

    if (tabId) {
      this.tabId = tabId
    }

    this.rowType = rowType;
    this.children = children;
    this.isShow = true;
    this.isEdit = false;


    isNewCol && (this.isNewCol = isNewCol);
    newType && (this.newType = newType);
  }
}

export default OneColumn;



// WEBPACK FOOTER //
// ./src/base/one_column.js